export class Point {
    static fromXYZ(x, y, z = 0) {
        const cls = new Point();
        cls.x = x;
        cls.y = y;
        cls.z = z;
        return cls;
    }
    constructor(VARS = {}, start = 10, index = null) {
        this.x = 0;
        this.y = 0;
        this.z = 0;
        this.touching = ({ x: x1, y: y1, z: z1 }) => {
            return x1 == this.x && y1 == this.y; //z1 == this.y;
        };
        this.scale = (by) => {
            return Point.fromXYZ(this.x / by, this.y / by, this.z / by);
        };
        this.multi = (by) => {
            return Point.fromXYZ(this.x * by.x, this.y * by.y, this.z / by.x);
        };
        this.addPoint = (by) => {
            return Point.fromXYZ(this.x + by.x, this.y + by.y, this.z + by.z);
        };
        this.midPoint = ({ x: x2, y: y2, z: z2 }) => {
            const x = (this.x + x2) / 2;
            const y = (this.y + y2) / 2;
            const z = (this.z + z2) / 2;
            return Point.fromXYZ(x, y, z);
        };
        this.distanceTo = (b) => {
            const xDiff = this.x - b.x;
            const yDiff = this.y - b.y;
            return Math.hypot(xDiff, yDiff);
        };
        if (VARS.X)
            this.x = index !== null ? VARS.X[start][index] : VARS.X[start];
        if (VARS.Y)
            this.y = index !== null ? VARS.Y[start + 10][index] : VARS.Y[start + 10];
        if (VARS.Z)
            this.z = index !== null ? VARS.Z[start + 20][index] : VARS.Z[start + 20];
        if (Array.isArray(this.x) && this.x.length == 1)
            this.x = this.x[0];
        if (Array.isArray(this.y) && this.y.length == 1)
            this.y = this.y[0];
        if (Array.isArray(this.z) && this.z.length == 1)
            this.z = this.z[0];
    }
}
export const LengthPoints = ({ x: x1, y: y1 }, { x: x2, y: y2 }) => {
    const xDiff = x2 - x1;
    const yDiff = y2 - y1;
    return Math.hypot(xDiff, yDiff);
};
export let SubPoint = (a, b) => {
    return Point.fromXYZ(a.x - b.x, a.y - b.y, a.z - b.z);
};
